import { motion } from "framer-motion";

import bicester from "../assets/trips/bicester.jpg";
import countryside from "../assets/trips/countryside.jpg";
import hunting from "../assets/trips/hunting.jpg";
import london from "../assets/trips/london.jpg";
import safari from "../assets/trips/safari.jpg";
import themepark from "../assets/trips/themepark.jpg";

function Trips() {
  return (
    <div className="page">

      {/* HEADER */}
<motion.div
  className="trips-header"
  initial={{ opacity: 0, y: 40 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.9 }}
>
  <h1 className="trips-title">Our Trips</h1>

  <p className="trips-subtitle">
    From London landmarks to the English countryside, enjoy unforgettable private journeys in absolute comfort.
  </p>
</motion.div>
      {/* TRIPS LIST */}
      <div className="trips-container">

        {/* HUNTING */}
        <motion.div
          className="trip-card"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={hunting} alt="hunting" />
          </div>

          <div className="trip-content">
            <h2>Hunting & Shooting Experience</h2>
            <p>
              Enjoy an exclusive countryside experience on private estates,
              offering pigeon, duck, and deer hunting alongside professional clay shooting sessions.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20Hunting%20Experience">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

        {/* THEME PARK */}
        <motion.div
          className="trip-card reverse"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={themepark} alt="theme park" />
          </div>

          <div className="trip-content">
            <h2>UK Premier Theme Parks</h2>
            <p>
              Thorpe Park, LEGOLAND, Peppa Pig World and more with luxury transport service.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20Theme%20Parks%20Trip">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

        {/* BICESTER */}
        <motion.div
          className="trip-card"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={bicester} alt="bicester" />
          </div>

          <div className="trip-content">
            <h2>Bicester Village Outlet</h2>
            <p>
              Luxury shopping with VIP access and world-class brands.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20Bicester%20Trip">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

        {/* LONDON */}
        <motion.div
          className="trip-card reverse"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={london} alt="london" />
          </div>

          <div className="trip-content">
            <h2>London Private City Tour</h2>
            <p>
              Buckingham Palace, Big Ben, Tower of London with private chauffeur.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20London%20Tour">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

        {/* COUNTRYSIDE */}
        <motion.div
          className="trip-card"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={countryside} alt="countryside" />
          </div>

          <div className="trip-content">
            <h2>English Countryside Escape</h2>
            <p>
              Peaceful landscapes and luxury rural getaway experience.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20Countryside%20Trip">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

        {/* SAFARI */}
        <motion.div
          className="trip-card reverse"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="trip-image">
            <img src={safari} alt="safari" />
          </div>

          <div className="trip-content">
            <h2>Safari Experience</h2>
            <p>
              Wildlife adventure with luxury comfort and private transport.
            </p>

            <a href="https://wa.me/447826699446?text=I%20am%20interested%20in%20Safari%20Trip">
              <button>Book Now</button>
            </a>
          </div>
        </motion.div>

      </div>
    </div>
  );
}

export default Trips;